module.exports = __webpack_public_path__ + "img/top-employer-2025.88862df4.png";